import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MuiModule } from '@move/ui';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { MmuCookieButtonsComponent } from './cookie-dialog/cookie-buttons/mmu-cookie-buttons.component';
import { MmuCookiePreferencesDialog } from './cookie-dialog/mmu-cookie-preferences-dialog.component';
import { MmuCookieSelectionComponent } from './cookie-selection/mmu-cookie-selection.component';
import { MmuFFEntGTMTrackingCookieSelectionComponent } from './FFEntGTMTrackingCookie-selection/mmu-cookie-selection.component';
import { MmuFFEntGTMTrackingCookiePreferencesDialog } from './FFEntGTMTrackingDialog/mmu-cookie-preferences-dialog.component';
import {
  MmuFFEntGTMTrackingGlobalPrivacyControlHintComponent
} from './FFEntGTMTrackingGlobal-privacy-control/mmu-global-privacy-control-hint.component';
import { MmuGlobalPrivacyControlHintComponent } from './global-privacy-control/mmu-global-privacy-control-hint.component';
import { MmuCookiePreferencesService } from './service/mmu-cookie-preferences.service';


@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    NgbModalModule,
    MuiModule
  ],
  declarations: [
    MmuCookiePreferencesDialog,
    MmuFFEntGTMTrackingCookiePreferencesDialog,
    MmuFFEntGTMTrackingCookieSelectionComponent,
    MmuCookieSelectionComponent,
    MmuGlobalPrivacyControlHintComponent,
    MmuFFEntGTMTrackingGlobalPrivacyControlHintComponent,
    MmuCookieButtonsComponent
  ], exports: [
    MmuCookieSelectionComponent,
    MmuCookieButtonsComponent,
    MmuGlobalPrivacyControlHintComponent,
    MmuCookiePreferencesDialog
  ]
})
export class MmuCookiesModule {

  /**
   * @deprecated: Please refactor your application to use MmuModule.forRoot() in near future.
   */
  static forRoot(): ModuleWithProviders<MmuCookiesModule> {
    return {
      ngModule: MmuCookiesModule,
      providers: [
        MmuCookiePreferencesService,
        CookieService
      ]
    };
  }
}
